import React from "react";
import styled from "styled-components";

interface FilterProps {
  className?: string;
  fill: string;
  imageSrc: string;
  maskSrc?: string;
  haveHover?: boolean;
}

export const ImageFilter = ({
  className,
  fill = "#EDA064",
  imageSrc = ``,
  maskSrc,
  haveHover = false,
}: FilterProps) => {
  return (
    <FilterWrapper
      className={`${className || ""} ${fill === "white" ? "no-mask" : ""}`}
      fill={fill}
      haveHover={haveHover}
    >
      <img className="main-image" src={imageSrc} alt="filter-main-image" />
      {fill !== "white" && maskSrc && (
        <img className="mask-image" src={maskSrc} alt="filter-mask-image" />
      )}
    </FilterWrapper>
  );
};

interface FilterWraperInterface {
  fill?: string;
  haveHover?: boolean;
}

const FilterWrapper = styled.div<FilterWraperInterface>`
  height: 100%;
  position: relative;
  aspect-ratio: 1 / 1;
  &.no-mask {
    .main-image {
      position: relative;
      top: auto;
      left: auto;
    }
  }

  .mask-image,
  .main-image {
    width: 100%;
    height: 100%;
  }

  .main-image {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .mask-image {
    background-color: ${(props) => props.fill};
    mix-blend-mode: multiply;
    margin-bottom: -4px;
    filter: brightness(0.94);
    ${({ haveHover }) =>
      haveHover &&
      `.image-container:hover {
    
    }`}
  }
`;
